import { unwrapResult } from "@reduxjs/toolkit"
import { Col, notification, Table, Tabs } from "antd"
import moment from "moment"
import React, { useContext, useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { RootDispatch } from "../../app/store"
import { TabBar, TabPane } from "../../compnents/widgets/TabBar"
import { InsuranceSettleRegionTotal } from "./InsuranceSettleRegionTotal"
import { InsuranceSettlementRecordList } from "./InsuranceSettlementRecord"
import styles from "./InsuranceSettlementRecord.module.css"


export const InsuranceSettlementTabs = () => {
  const dispatch = useDispatch<RootDispatch>()

  const [activeKey, setActiveKey] = useState<string>("0")

  return (
    <Col
       className={styles.container}
    >
      <TabBar
       style={{ height: "100%" }}
        activeKey={activeKey}
        defaultActiveKey="0"
        onChange={(v) => {
          setActiveKey(v) 
        }}
      >
        <TabPane tab="医保结算明细" key={"0"} style={{ height: "100%" }}>
          <InsuranceSettlementRecordList />
        </TabPane>
        <TabPane tab="医保结算地区汇总" key={"1"} style={{ height: "100%" }}>
          <InsuranceSettleRegionTotal />
        </TabPane>
      </TabBar>
    </Col>
  )
}
